// Typed client generated from api/openapi.yaml (ARC-06). Regenerate with
// `npm run gen:api`; CI fails if src/api/schema.d.ts is stale.
import createClient from "openapi-fetch";
import type { components, paths } from "./schema";

// The app lives under /security (Vite base) so a front reverse proxy can share one public
// address between applications; the web server strips the prefix before proxying to the api.
export const api = createClient<paths>({ baseUrl: `${import.meta.env.BASE_URL}api/v1`, credentials: "same-origin" });

export type Schemas = components["schemas"];
export type ApiError = Schemas["ErrorBody"]["error"];
